import { apiGet, apiPost } from "./Api/apiCall";
import { OpenPresenceResponse, PresenceTarget, PresenceUsersResponse } from "../types/Presence";

export const PRESENCE_HEARTBEAT_INTERVAL_MS = 10000;
export const PRESENCE_TTL_SECONDS = 25;
export const PRESENCE_MAX_VISIBLE_AVATARS = 5;

export const openPresenceSession = (
  presenceTarget: PresenceTarget,
  tabId: string | null,
): Promise<OpenPresenceResponse> => {
  return apiPost(`/api/${presenceTarget}/presence`, { tabId });
};

export const getPresenceSnapshot = (presenceTarget: PresenceTarget): Promise<PresenceUsersResponse> => {
  return apiGet(`/api/${presenceTarget}/presence`);
};

export const sendPresenceHeartbeat = (presenceId: string, tabId: string | null): Promise<PresenceUsersResponse> => {
  return apiPost(`/api/presence/${presenceId}/heartbeat`, { tabId });
};

export const closePresenceSession = (
  presenceId: string,
  data: { tabId: string; closeToken: string },
): Promise<null> => {
  return apiPost(`/api/presence/${presenceId}`, data, {
    keepalive: true,
  });
};
